// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"953cdd08","101":"e6235618","186":"d5bbd8f4","213":"e10593dd","610":"2448617f","642":"450183cd","995":"82b2dab8"}[chunkId] + ".chunk.js";
};